// extracted by mini-css-extract-plugin
module.exports = {"appContent":"App_appContent__1pITD"};